'use strict';

module.exports = (function () {

	var startOfYear;
    var startOfYesterday;
    var startOfToday;
    var startOfTomorrow;
    var startOfDayAfterTomorrow;
    var startOfNextYear;
	var monthNames = [
		"jan", "feb", "mar",
		"apr", "maj", "jun", "jul",
		"aug", "sep", "okt",
		"nov", "dec"
	];
	var weekDays = ["sön", "mån", "tis", "ons", "tor", "fre", "lör"];

	function _initDays(now) {
		var oneDay = 24 * 60 * 60 * 1000;

		startOfToday = new Date(now);
		startOfToday.setHours(0, 0, 0, 0);

		startOfTomorrow = new Date();
		startOfTomorrow.setTime(startOfToday.getTime() + oneDay);

		startOfDayAfterTomorrow = new Date(startOfToday.getTime() + (2 * oneDay));

		startOfNextYear = new Date(startOfToday.getTime());
		startOfNextYear.setFullYear(startOfNextYear.getFullYear() + 1);
		startOfNextYear.setMonth(0, 1);

		startOfYesterday = new Date(startOfToday.getTime() - oneDay);

		startOfYear = new Date(startOfToday.getTime());
		startOfYear.setMonth(0, 1);
	}

	return {
		getFormattedTime: function (timestamp) {
			if (timestamp < 0) {
				return '--:--';
			}

			var hours = timestamp > 3600 ? Math.floor(timestamp / 3600) : null;
            var minutes = timestamp >= 60 ? Math.floor((timestamp % 3600) / 60) : 0;
            var seconds = timestamp >= 60 ? Math.floor(timestamp % 60) : Math.floor(timestamp);

			if (isNaN(seconds)) {
				seconds = 0;
			}

			minutes = minutes <= 9 ? '0' + minutes : minutes;
			seconds = seconds <= 9 ? '0' + seconds : seconds;

			return (hours !== null ? hours + ':' : '') + minutes + ':' + seconds;
		},
		getFormattedVideoLength: function (timestamp) {
			var roundedHours = timestamp >= 3600 ? Math.round(timestamp / 3600) : null;
            var hours = timestamp >= 3600 ? Math.floor(timestamp / 3600) : null;
            var minutes = timestamp >= 60 ? Math.round((timestamp % 3600) / 60) : 0;
            var seconds = timestamp >= 60 ? Math.round(timestamp % 60) : Math.round(timestamp);

			//follow the rules from styleguide http://styleguide.svt.se/style/text.html
			if (hours && hours >= 8) {
				return roundedHours + ' tim';
			} else if (hours && minutes) {
				return hours + ' tim ' + minutes + ' min';
			} else if (hours) {
				return hours + ' tim';
			} else if (minutes) {
				return minutes + ' min';
			} else {
				return seconds ? seconds + ' sek' : '';
			}
		},
		formatPrettyVideoDate: function (date) {
			var now = new Date();
            var hours = date.getHours();
            var minutes = date.getMinutes();
			minutes = minutes <= 9 ? '0' + minutes : minutes;
			hours = hours <= 9 ? '0' + hours : hours;
			var time = hours + '.' + minutes;
			var result = '';

			if (startOfTomorrow === undefined || startOfTomorrow < now) {
				_initDays(now);
			}

			if (date > startOfNextYear) {
				//d LLL yyy
				result = date.getDate() + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
			} else if (date > startOfDayAfterTomorrow) {
				//EEE d LLL
				result = weekDays[date.getDay()] + ' ' + date.getDate() + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
			} else if (date > startOfTomorrow) {
				//imorgon HH.mm
				result = 'imorgon ' + time;
			} else if (date > startOfToday && date.getHours() >= 18) {
				//ikväll' HH.mm
				result = 'ikväll ' + time;
			} else if (date > startOfToday && date.getHours() < 18) {
				//'idag' HH.mm'
				result = 'idag ' + time;
			} else if (date > startOfYesterday) {
				//'igår' HH.mm'
				result = 'igår ' + time;
			} else if (date > startOfYear) {
				//'EEE d LLL'
				result = weekDays[date.getDay()] + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
			} else {
				//'d LLL yyy'
				result = date.getDate() + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
			}

			return result;
		}
	};
})();



// WEBPACK FOOTER //
// ./src/js/util/time.js